import * as types from '../../action-types';
import {deleteConsumer as initialState } from "../../initialState";

const deleteConsumer = (state=initialState, action) => {
  switch (action.type) {
    case types.DELETE_CONSUMER_START:
      return {
        ...state,
        isLoading: true
      };
    case types.DELETE_CONSUMER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.DELETE_CONSUMER_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.DELETE_CONSUMER_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default deleteConsumer;
